import { useMemo } from 'react';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { MenuItem, Select, FormControl, SelectChangeEvent } from '@mui/material';
import { changeUserLocale } from '@containers/Admin/containers/UserPage/actions';
import { SELECTOR_WIDTH, LANGUAGE_OPTIONS } from './consts';

type SelectLanguageProps = {
  isMentor: boolean;
};

export const SelectLanguage = ({ isMentor }: SelectLanguageProps) => {
  const dispatch = useDispatch();
  const {
    userData: { id, locale },
  } = useSelector((state: RootStateOrAny) => state.get('userPage').toJS()); // FIXME replace to typing store

  const updateUserLocale = (event: SelectChangeEvent): void => {
    dispatch(changeUserLocale(event.target.value, id));
  };

  const selectedLanguage = useMemo(() => LANGUAGE_OPTIONS.find(({ value }) => value === locale), [locale]);

  if (isMentor) return locale && selectedLanguage?.label ? selectedLanguage.label : 'No language';

  return (
    <div>
      {locale && (
        <FormControl sx={{ width: SELECTOR_WIDTH }} size="small">
          <Select
            value={selectedLanguage?.value}
            onChange={updateUserLocale}
            renderValue={() => selectedLanguage?.label}
          >
            {LANGUAGE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value} selected={option.value === locale}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </div>
  );
};
